<div class="custom-modal-layout">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Email Icon" />
    </div>
    <span class="title">{{ isEditMode ? 'Editar programa' : 'Novo programa' }}</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()"></p-button>
  </div>
  <form [formGroup]="programaForm" (ngSubmit)="save()">
    <div class="p-fluid grid">
      <div class="field col-12">
        <label for="nome">Nome do Programa</label>
        <input id="nome" type="text" class="w-full" pInputText formControlName="nome" placeholder="Nome do programa" />
        <div *ngIf="programaForm.get('nome')?.invalid && programaForm.get('nome')?.touched"
          class="error-message">
          Nome do programa é obrigatório
        </div>
      </div>
      <!-- <div class="field col-6">
        <label for="valorMensal">Valor Mensal</label>
        <input id="valorMensal" type="number" class="w-full" pInputText formControlName="valorMensal"
          placeholder="Valor Mensal" />
      </div> -->
      <div class="field col-6">
        <label for="valorMensal">Valor Mensal</label>
        <input pInputText id="valorMensal" type="text" class="w-full" formControlName="valorMensal"
          placeholder="Valor Mensal" mask="separator.2" thousandSeparator=" " decimalMarker=",">
        <div *ngIf="programaForm.get('valorMensal')?.invalid && programaForm.get('valorMensal')?.touched"
          class="error-message">
          Valor mensal do programa é obrigatório
        </div>
      </div>
      <div class="field col-6">
        <label for="duracaoMeses">Duração (Meses)</label>
        <input id="duracaoMeses" type="number" class="w-full" pInputText formControlName="duracaoMeses"
          placeholder="Duração em meses" />
        <div *ngIf="programaForm.get('duracaoMeses')?.invalid && programaForm.get('duracaoMeses')?.touched"
          class="error-message">
          Duração do programa é obrigatório
        </div>
      </div>
      <div class="field col-6">
        <label for="tipo">Tipo</label>
        <p-select appendTo="body" [showClear]="true" id="tipo" class="w-full" formControlName="tipo"
          [options]="tiposPrograma" optionLabel="label" optionValue="value" placeholder="Tipo de programa"></p-select>
        <div *ngIf="programaForm.get('tipo')?.invalid && programaForm.get('tipo')?.touched"
          class="error-message">
          Tipo de programa é obrigatório
        </div>
      </div>
      <div class="field col-6">
        <label for="cobertura">Cobertura</label>
        <p-select appendTo="body" [showClear]="true" id="cobertura" class="w-full" formControlName="cobertura"
          [options]="coberturas" optionLabel="label" optionValue="value" placeholder="Cobertura"></p-select>
        <div *ngIf="programaForm.get('cobertura')?.invalid && programaForm.get('cobertura')?.touched"
          class="error-message">
          Cobertura do programa é obrigatório
        </div>
      </div>
      <div class="field col-6 flex flex-column">
        <label for="dataInicio">Data de Início</label>
        <p-datepicker appendTo="body" id="dataInicio" class="w-full d-contents" formControlName="dataInicio"
          dateFormat="dd/mm/yy" />
        <div *ngIf="programaForm.get('dataInicio')?.invalid && programaForm.get('dataInicio')?.touched"
          class="error-message">
          Data de início do programa é obrigatório
        </div>
      </div>
      <div class="field col-6 flex flex-column">
        <label for="dataTermino">Data de Fim</label>
        <p-datepicker appendTo="body" id="dataTermino" class="w-full d-contents" formControlName="dataFim"
          dateFormat="dd/mm/yy" />
        <div *ngIf="programaForm.get('dataFim')?.invalid && programaForm.get('dataFim')?.touched"
          class="error-message">
          Data de fim é obrigatório
        </div>
      </div>
      <div *ngIf="programaForm.hasError('dataInicioFimRange')" class="error-message">
        Data de fim não pode ser anterior à data de início
      </div>
      <div class="field col-12">
        <label for="descricao">Descrição</label>
        <textarea id="descricao" class="w-full" pTextarea formControlName="descricao"
          placeholder="Descrição do programa"></textarea>
      </div>

    </div>
    <div class="modal-footer" style="margin-top: -10px !important;">
      <p-button class="p-button-outlined" label="Cancelar" (click)="cancel()"></p-button>
      <button pButton type="submit" label="{{ isEditMode ? 'Salvar' : 'Adicionar' }}" class="p-button-primary"></button>
    </div>
  </form>
</div>

<p-toast></p-toast>